import {AccessesBySection, UserRoleEnum} from '@/model/enums/UserRoleEnum';
import { RouteRecordRaw } from 'vue-router';
import { TicketsRoutesEnum } from './TicketsRoutesEnum';

const TicketsPage       = () => import(
    /* webpackChunkName: "Tickets-module" */ 
    '../pages/tickets/TicketsPage.vue'
);
const TicketPage        = () => import(
    /* webpackChunkName: "Tickets-module" */ 
    '../pages/ticket/TicketPage.vue'
);
const TicketData        = () => import(
    /* webpackChunkName: "Tickets-module" */ 
    '../pages/ticket/TicketData/TicketData.vue'
);
const TicketHistoryMap  = () => import(
    /* webpackChunkName: "Tickets-module" */ 
    '../pages/ticket/TicketHistoryMap/TicketHistoryMap.vue'
);
const TicketGallery  = () => import(
    /* webpackChunkName: "Tickets-module" */
    '../pages/ticket/TicketGallery/TicketGallery.vue'
    );


const routes:  Array<RouteRecordRaw> = [
    {
        path: '/tickets',
        name: TicketsRoutesEnum.TICKETS_LIST,
        component: TicketsPage,
        meta: {
            tabTitle: "Tickets list",
			breadCrumbItems: [
				{label: 'Tickets list'},
			],
            roles: AccessesBySection.TICKETS
		}
    },
    {
        path      : '/tickets/:ticketId',
        props     : true,
        component : TicketPage,
        meta: {
            tabTitle: "Ticket detail",
			breadCrumbItems: [
				{
                    label: 'Tickets list', 
                    to: { name: TicketsRoutesEnum.TICKETS_LIST } 
                },
                { label: 'Ticket detail' },
			],
            roles: AccessesBySection.TICKETS
		},
        children: [
            {
                path      : '',
                name      : TicketsRoutesEnum.TICKETS_DETAIL,
                component : TicketData,
            },
            {
                path      : 'history',
                name      : TicketsRoutesEnum.TICKETS_DETAIL_HISTORY,
                component : TicketHistoryMap,
            },
            {
                path      : 'gallery',
                name      : TicketsRoutesEnum.TICKETS_GALLERY,
                component : TicketGallery,
            },
        ]
    },
];

export { routes };
export { TicketsRoutesEnum };
